import { StringId } from '../../../../model/string-id';
import { InternalLinkComponent } from '../internal-link/internal-link.component';

export enum ToastType {
  SUCCESS = 'success',
  INFORMATION = 'info',
  WARNING = 'warn',
  ERROR = 'error',
}

export enum ToastLife {
  SHORT = 'SHORT',
  LONG = 'LONG',
}

export interface ToastData {
  text: StringId;
  textParams?: (string | number)[];
  title?: StringId;
  titleParams?: (string | number)[];
  toastLife?: ToastLife;
  type?: ToastType;
  skipTranslation?: boolean;
  supportLineBreaks?: boolean;
  internalLink?: {
    link: InternalLinkComponent['link'];
    queryParams?: InternalLinkComponent['queryParams'];
    text: StringId;
    state?: InternalLinkComponent['state'];
  };
}
